import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AboutSection } from './components/AboutSection';
import { OfferSection } from './components/OfferSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2433320707143614');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2433320707143614&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-white text-brand-dark font-sans selection:bg-brand-pink/30 selection:text-brand-purple" data-id="element-0">
      {/* Urgency Bar */}
      <div className="bg-white text-brand-purple text-center py-3 px-5 font-semibold text-[0.95rem] tracking-[0.5px]" data-id="element-1">
        📥 Descarga inmediata · Sin esperas · Acceso al instante
      </div>

      {/* Sticky Nav */}
      <nav className="bg-brand-purple py-[18px] px-10 flex justify-between items-center sticky top-0 z-[100]" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/cYknYAv4px6H22WJwF3nuP/INK_1_PNG.png" alt="Inkova" className="h-10" data-id="element-3" />
        <a href="#cta" className="bg-brand-pink text-brand-white border-none py-3 px-7 rounded-full font-semibold text-[0.95rem] cursor-pointer no-underline transition-colors hover:bg-[#c478ae]" data-id="element-4">
          Descargar Guía — $33
        </a>
      </nav>

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <AboutSection data-id="element-9" />
        <OfferSection data-id="element-10" />
      </main>

      {/* Footer */}
      <footer className="bg-brand-dark text-white/50 text-center p-7 text-[0.85rem]" data-id="element-11">
        <p className="mb-[6px]" data-id="element-12">
          © {new Date().getFullYear()} Inkova LLC ·{' '}
          <a href="https://go.inkovacreation.com" className="text-brand-pink no-underline hover:underline" data-id="element-13">
            go.inkovacreation.com
          </a>
        </p>
        <p data-id="element-14">
          <a href="#" className="text-brand-pink no-underline hover:underline" data-id="element-15">
            Política de Privacidad
          </a>{' '}
          ·{' '}
          <a href="#" className="text-brand-pink no-underline hover:underline" data-id="element-16">
            Términos de Uso
          </a>
        </p>
      </footer>
    </div>;
}